import React, { createContext, useContext, useState, useEffect } from 'react'
import featureFlags from 'featureFlags.json'

declare global {
  interface Window {
    setFeatureFlag: any
    REACT_APP_FEATURE_FLAGS: { [key: string]: boolean }
    REACT_APP_PORTAL_URL: string
    REACT_APP_LOGIN_READONLY: boolean
    REACT_APP_DISABLE_BOOKING_LIMITS: boolean
  }
}

const overrideFlags = window.REACT_APP_FEATURE_FLAGS || {}

export const flagValues = { ...featureFlags, ...overrideFlags }

export const FeatureFlagsContext = createContext(flagValues)

export const FeatureFlagsProvider: React.FunctionComponent = ({ children }) => {
  const [flags, setFlags] = useState(flagValues)

  useEffect(() => {
    window.setFeatureFlag = (name: string, enabled: boolean) => {
      setFlags((fs: any) => {
        if (name in fs) {
          return { ...fs, [name]: enabled }
        } else {
          console.error(`No flag named ${name} exists`)
          return fs
        }
      })
    }

    return () => {
      window.setFeatureFlag = undefined
    }
  }, [setFlags])

  return (
    <FeatureFlagsContext.Provider value={flags}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}

export const useFeatureFlags = () => useContext(FeatureFlagsContext)
